import { render, staticRenderFns } from "./RequestRoadsBody.vue?vue&type=template&id=93794906&scoped=true&"
import script from "./RequestRoadsBody.vue?vue&type=script&lang=js&"
export * from "./RequestRoadsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93794906",
  null
  
)

export default component.exports
import {QExpansionItem,QCardSection,QItem,QInput,QField} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QCardSection,QItem,QInput,QField}, component.options.components || {})
